import { Icon, Image } from '@/components'
import { Mirrors } from '@/components/common/mirrors'
import { URL_DECOR } from '@/constants/ui'
import { Stack, StackProps, Typography } from '@mui/material'
import Link from 'next/link'
interface IReturnTagProps {
  props?: Omit<StackProps, 'children'>
}
export const ReturnTag = ({ props }: IReturnTagProps) => {
  return (
    <Link href="https://hydrashop.vn/help/chinh-sach-giao-hang/" target="_blank" style={{ display: 'block' }}>
      <Stack
        direction={'row'}
        p={1}
        borderRadius={'8px'}
        alignItems={'center'}
        justifyContent={{ xs: 'center', sm: 'flex-start' }}
        {...props}
        sx={{
          backgroundColor: '#0465C6',
          position: 'relative',
          overflow: 'hidden',
          color: 'white',
          width: { xs: '100%', sm: 'fit-content' },
          transition: ' 0.3s ease-in-out',
          '&:hover': {
            transform: 'translateY(-2px)',
          },
          ...props?.sx,
        }}
      >
        <Image
          src={URL_DECOR + 'blue-tag.png'}
          alt=""
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        <Mirrors />
        <Icon.Defend sx={{ fontSize: '20px', position: 'relative', zIndex: 1, marginRight: '8px' }} />
        <Stack sx={{ position: 'relative', zIndex: 1 }}>
          <Typography
            sx={{ fontSize: { xs: '0.875rem', md: '1rem' }, color: 'inherit', lineHeight: 1.5 }}
            fontWeight={600}
          >
            BẠN CÓ 15 NGÀY
          </Typography>
          <Typography
            sx={{ fontSize: { xs: '0.5rem', md: '0.75rem' }, color: 'inherit', lineHeight: 1.5 }}
            variant="body2"
            fontWeight={600}
            color="inherit"
          >
            TRẢ HÀNG KHÔNG CẦN LÝ DO
          </Typography>
        </Stack>
      </Stack>
    </Link>
  )
}
